import PropTypes from "prop-types";

import Presenter from "utils/PropTypesPresenter";

export default new Presenter({
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  lastFour: PropTypes.string,
  cardType: PropTypes.string,
  month: PropTypes.string,
  year: PropTypes.string,
  zip: PropTypes.string,
});
